import React from "react";
import HeaderComponent from "./header.component";

export default function HeaderContainer({
  justifyContent,
  imgClass
}) {
  return <HeaderComponent justifyContent={justifyContent} imgClass={imgClass} />;
}